import React from 'react'

import { styled } from '~/styled'

import { Badge } from '../badge/Badge'
import { Icon } from '../icon/Icon'

const StyledBadge = styled(Badge, {
  base: [
    'font-body',
    'text-sm',
    'flex-row',
    'justify-center',
    'absolute',
    'top-0',
    'right-0',
    'translate-x-3',
    '-translate-y-1/2',
    'rounded-full',
    'h-6',
    'min-w-6',
    'text-center'
  ]
})

type BadgeProps = React.ComponentProps<typeof Badge>

type NotificationBadgeProps = {
  value: number | string
  emphasis?: BadgeProps['emphasis']
  theme?: BadgeProps['theme']
  icon?: React.FC<React.SVGProps<SVGSVGElement>>
}

export const NotificationBadge = ({
  value,
  emphasis = 'bold',
  theme = 'primary',
  icon,
  children
}: React.PropsWithChildren<NotificationBadgeProps>) => (
  <div className="relative">
    {!!value && (
      <StyledBadge role="status" emphasis={emphasis} theme={theme}>
        {icon && <Icon is={icon} role="img" aria-hidden="false" />}
        {value}
      </StyledBadge>
    )}
    {children}
  </div>
)
